import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callDealGetApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.deal);
  return data;
};